import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { useNavigate } from 'react-router';
import { ParkingaboLayoutWithHeader } from '../components/layout/ParkingaboLayoutWithHeader.tsx';
import { Typography, Box, Link, Stack } from '@mui/material';
import { useCustomerContext } from '../components/CustomerProvider.tsx';
import { Message } from 'dg-web-shared/lib/Localized.ts';
import { ParkingaboContact } from 'product-shared/parkingabo/ParkingaboContact.ts';
import { ParkingaboFooter } from '../components/layout/ParkingaboFooter.tsx';

export function ParkingaboHelp() {
    const navigate = useNavigate();
    const {
        user: { operatorExternalId, operatorName, parkingaboContact },
    } = useCustomerContext();
    return (
        <ParkingaboLayoutWithHeader
            noGutter
            scrollable
            title={<Localized de="Hilfe" fr="Aide" it="Aiuto" en="Help" />}
            onBack={() => navigate(-1)}
        >
            <Box sx={theme => ({ padding: theme.spacing(3) })}>
                <Typography>
                    <Localized
                        de="Bei Bedarf wenden Sie sich bitte anhand der folgenden Kontaktdaten an den Parkplatzbetreiber."
                        fr="Si nécessaire, veuillez contacter le gestionnaire du parking en utilisant les coordonnées suivantes."
                        it="Se necessario, la preghiamo di contattare il gestore del parcheggio utilizzando i seguenti recapiti."
                        en="If necessary, please contact the car park operator using the contact details below."
                    />
                </Typography>
                <ParkingaboContactInfo
                    operatorName={operatorName}
                    parkingaboContact={parkingaboContact}
                />
            </Box>
            <ParkingaboFooter operatorExternalId={operatorExternalId} />
        </ParkingaboLayoutWithHeader>
    );
}

export function ParkingaboContactInfo({
    operatorName,
    parkingaboContact,
}: {
    operatorName: string;
    parkingaboContact: ParkingaboContact | null;
}) {
    return (
        <Stack
            spacing={0.5}
            sx={theme => ({
                marginTop: theme.spacing(3),
            })}
        >
            <Typography
                variant="h3"
                sx={theme => ({ paddingBottom: theme.spacing(0.5) })}
            >
                {operatorName}
            </Typography>
            <ParkingaboContactDisplay parkingaboContact={parkingaboContact} />
        </Stack>
    );
}

function ParkingaboContactDisplay({
    parkingaboContact,
}: {
    parkingaboContact: ParkingaboContact | null;
}) {
    if (!parkingaboContact) {
        return (
            <Typography sx={{ fontStyle: 'italic' }}>
                <Localized
                    de="Kontaktdaten fehlen"
                    fr="Coordonnées manquantes"
                    it="Dati di contatto mandanti"
                    en="Missing contact details"
                />
            </Typography>
        );
    }
    return (
        <>
            {parkingaboContact && (
                <>
                    <ParkingaboContactEmail email={parkingaboContact.email} />
                    <ParkingaboContactPhone phone={parkingaboContact.phone} />
                    <ParkingaboContactAdditionalInfo
                        additionalInfo={parkingaboContact.additionalInfo}
                    />
                </>
            )}
        </>
    );
}

function ParkingaboContactEmail({ email }: { email: string | null }) {
    if (!email) {
        return null;
    }

    return (
        <Typography>
            <Link
                sx={{
                    fontWeight: 400,
                }}
                underline="always"
                href={`mailto:${email}`}
            >
                {email}
            </Link>
        </Typography>
    );
}

function ParkingaboContactPhone({ phone }: { phone: string | null }) {
    if (!phone) {
        return null;
    }

    return (
        <Typography>
            <Link
                sx={{
                    fontWeight: 400,
                }}
                underline="always"
                href={`tel:${phone}`}
            >
                {phone}
            </Link>
        </Typography>
    );
}

function ParkingaboContactAdditionalInfo({
    additionalInfo,
}: {
    additionalInfo: Message | null;
}) {
    if (!additionalInfo) {
        return null;
    }

    return (
        <Typography>
            <Localized {...additionalInfo} />
        </Typography>
    );
}
